var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      staticClass: "review-modal",
      attrs: { scrollable: "", visible: _vm.shown },
      on: { "on-close": _vm.onClose }
    },
    [
      _c("div", { staticClass: "review-form" }, [
        _c("div", { staticClass: "review-form__inputs-wrap" }, [
          _c("div", { staticClass: "review-form__title" }, [
            _vm._v("\n        Оcтавить отзыв\n      ")
          ]),
          _c(
            "div",
            { staticClass: "review-form__inputs-wrap-user" },
            [
              _c("ui-input", {
                ref: "name",
                attrs: {
                  placeholder: "Имя",
                  label: "Имя*",
                  validate: "name",
                  clearable: ""
                },
                model: {
                  value: _vm.name,
                  callback: function($$v) {
                    _vm.name = $$v
                  },
                  expression: "name"
                }
              }),
              _c("ui-city-suggest", {
                attrs: {
                  label: "Город*",
                  current: { id: _vm.cityValue.id, name: _vm.cityValue.name }
                },
                on: { change: _vm.setCity }
              })
            ],
            1
          )
        ]),
        _c(
          "div",
          { staticClass: "review-form__stats-wrap" },
          [
            _c("stars-input", {
              ref: "rating",
              staticClass: "review-form__main-rating",
              attrs: {
                required: "",
                label: "Оценка товара*",
                large: "",
                "error-message": "Оцените товар",
                "label-left": "ужасно",
                "label-right": "отлично"
              },
              model: {
                value: _vm.rating,
                callback: function($$v) {
                  _vm.rating = $$v
                },
                expression: "rating"
              }
            }),
            _c(
              "div",
              { staticClass: "review-form__inputs-group" },
              [
                _c("stars-input", {
                  staticClass: "review-form__secondary-rating",
                  attrs: { label: "Посадка" },
                  model: {
                    value: _vm.fitRating,
                    callback: function($$v) {
                      _vm.fitRating = $$v
                    },
                    expression: "fitRating"
                  }
                }),
                _c("stars-input", {
                  staticClass: "review-form__secondary-rating",
                  attrs: { label: "Качество" },
                  model: {
                    value: _vm.qualityRating,
                    callback: function($$v) {
                      _vm.qualityRating = $$v
                    },
                    expression: "qualityRating"
                  }
                }),
                _c("stars-input", {
                  staticClass: "review-form__offset-rating",
                  attrs: { label: "Соответствие фото" },
                  model: {
                    value: _vm.photoAccuracyRating,
                    callback: function($$v) {
                      _vm.photoAccuracyRating = $$v
                    },
                    expression: "photoAccuracyRating"
                  }
                })
              ],
              1
            ),
            _c("review-radio-stats", {
              ref: "size",
              staticClass: "review-form__size",
              attrs: {
                label: "Размер*",
                options: _vm.sizeOptions,
                required: "",
                "error-message": "Выберите размер"
              },
              model: {
                value: _vm.size,
                callback: function($$v) {
                  _vm.size = $$v
                },
                expression: "size"
              }
            }),
            _c("review-radio-stats", {
              attrs: {
                label: "Срок использования",
                options: _vm.timeUsageOptions
              },
              model: {
                value: _vm.timeUsage,
                callback: function($$v) {
                  _vm.timeUsage = $$v
                },
                expression: "timeUsage"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          {
            staticClass:
              "review-form__inputs-wrap review-form__inputs-wrap-text"
          },
          [
            _c("input-group-head", {
              staticClass: "review-form__textarea-label",
              attrs: { label: "Достоинства", large: "" }
            }),
            _c("ui-textarea", {
              staticClass: "review-form__textarea",
              attrs: {
                height: _vm.textareaHeight,
                placeholder: "Что вам понравилось?"
              },
              model: {
                value: _vm.advantages,
                callback: function($$v) {
                  _vm.advantages = $$v
                },
                expression: "advantages"
              }
            }),
            _c("input-group-head", {
              staticClass: "review-form__textarea-label",
              attrs: { label: "Недостатки", large: "" }
            }),
            _c("ui-textarea", {
              staticClass: "review-form__textarea",
              attrs: {
                height: _vm.textareaHeight,
                placeholder: "Что не оправдало ваших ожиданий?"
              },
              model: {
                value: _vm.disadvantages,
                callback: function($$v) {
                  _vm.disadvantages = $$v
                },
                expression: "disadvantages"
              }
            }),
            _c("input-group-head", {
              staticClass: "review-form__textarea-label",
              attrs: { label: "Отзыв о товаре*", large: "" }
            }),
            _c("ui-textarea", {
              staticClass: "review-form__textarea",
              attrs: {
                height: _vm.textareaHeight,
                placeholder: "Поделитесь вашими впечатлениями о товаре",
                error: _vm.reviewError
              },
              on: { focus: _vm.clearError },
              model: {
                value: _vm.review,
                callback: function($$v) {
                  _vm.review = $$v
                },
                expression: "review"
              }
            }),
            _c("ui-checkbox", {
              staticClass: "review-form__checkbox",
              attrs: { label: "Я рекомендую этот товар к покупке" },
              model: {
                value: _vm.recommended,
                callback: function($$v) {
                  _vm.recommended = $$v
                },
                expression: "recommended"
              }
            }),
            _c("ui-button", {
              ref: "submitBtn",
              attrs: {
                disabled: !_vm.isValuesValid,
                wide: "",
                text: "Оставить отзыв"
              },
              on: { click: _vm.submit }
            }),
            _c("div", { staticClass: "review-form__agreement" }, [
              _vm._v(
                "\n        Нажимая на кнопку «Оставить отзыв»,\n        вы принимаете условия\n        "
              ),
              _c("a", { attrs: { target: "_blank", href: "/agreement" } }, [
                _vm._v("пользовательского соглашения")
              ]),
              _vm._v("\n        и "),
              _c("a", { attrs: { target: "_blank", href: "/content_rules" } }, [
                _vm._v("правила публикации пользовательского контента")
              ])
            ])
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }